import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EncuestaPendiente } from 'src/app/servicios/encuesta-satisfaccion/encuesta-satisfaccion.service';
import { MessageService } from 'src/app/servicios/message/message.service';

export interface FormularioEncuestaDialogData extends Partial<EncuestaPendiente> {
  /** `readonly` = vista Developer (sin editar). Por defecto se puede responder. */
  modo?: 'responder' | 'readonly';
  respuestas?: {
    indiceRecomendacion?: number | null;
    satisfaccionGeneral?: number | null;
    facilidadUso?: number | null;
    utilidadModulos?: number | null;
    comentario?: string | null;
  } | null;
}

@Component({
  selector: 'app-formulario-encuesta-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  templateUrl: './formulario-encuesta-dialog.component.html',
  styleUrls: ['./formulario-encuesta-dialog.component.scss'],
})
export class FormularioEncuestaDialogComponent implements OnInit {
  readonly data = inject<FormularioEncuestaDialogData | null>(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<FormularioEncuestaDialogComponent>);
  private fb = inject(FormBuilder);
  private messageService = inject(MessageService);
  private translate = inject(TranslateService);

  readonly isReadonly = this.data?.modo === 'readonly';

  readonly indiceRecomendacionOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  readonly likertOptions = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
  ];

  form = this.fb.group({
    indiceRecomendacion: [null as number | null, Validators.required],
    satisfaccionGeneral: [null as number | null, Validators.required],
    facilidadUso: [null as number | null, Validators.required],
    utilidadModulos: [null as number | null, Validators.required],
    comentario: [''],
  });

  ngOnInit(): void {
    if (!this.isReadonly) return;

    const r = this.data?.respuestas;
    if (r) {
      this.form.patchValue({
        indiceRecomendacion: r.indiceRecomendacion ?? null,
        satisfaccionGeneral: r.satisfaccionGeneral ?? null,
        facilidadUso: r.facilidadUso ?? null,
        utilidadModulos: r.utilidadModulos ?? null,
        comentario: r.comentario ?? '',
      });
    }
    this.form.disable({ emitEvent: false });
  }

  seleccionar(
    control: 'indiceRecomendacion' | 'satisfaccionGeneral' | 'facilidadUso' | 'utilidadModulos',
    value: number
  ) {
    if (this.isReadonly) return;
    this.form.get(control)?.setValue(value);
    this.form.get(control)?.markAsTouched();
  }

  cerrar() {
    this.dialogRef.close();
  }

  enviar() {
    if (this.isReadonly) return;

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.messageService.SwalMessage(
        'warning',
        this.translate.instant('completar_obligatorias')
      );
      return;
    }

    const respuestas = {
      version: 1,
      ...this.form.getRawValue(),
    };

    this.dialogRef.close({ enviada: true, respuestas });
  }
}
